import { QSetReviewHistoryList } from '@exam-management/qset-review-history';
import { Flex, PaperSection } from '@shared/components';

export default function QSetReviewHistoryPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        minHeight: '100dvh',
        p: theme.spacing(6),
      })}
    >
      <Flex sx={{ flexGrow: 1 }}>
        <PaperSection title='Review History'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              p: theme.spacing(6),
              gap: theme.spacing(6),
              height: '100%',
            })}
          >
            <QSetReviewHistoryList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
